<div class="desktop">
    <button *ngIf="communitiesCount > 1" [matMenuTriggerFor]="menu"
            mat-button>{{ selectedCommunity?.name || 'Select community' }}
    </button>
</div>

<button *ngIf="communitiesCount > 1" [matMenuTriggerFor]="menu" class="tablet d-flex" mat-menu-item>
    <span>Communities</span>
</button>

<mat-menu #menu="matMenu">
    <button (click)="selectOption(community.id)" *ngFor="let community of communities"
            [class.activeCommunityBtn]="community.id === selectedCommunity?.id"
            mat-menu-item>
        {{ community.name }}
    </button>
</mat-menu>
